// extracted by css-extract-rspack-plugin
var _1 = "Lfno4JiA4xAtIlkP";
export { _1 as "container" }
